export const catalogueStyles = {
  width: 300,
  height: "calc(100vh - 50px)",
  padding: "30px",
};
